export default __webpack_public_path__ + "static/1296-0d70c7b313d14081c2d82f9a521369e7.png";